export const IS_DEV = process.env.NODE_ENV === 'development';
// REACT_APP_PROXY 为空 → Railway 全栈同域，用相对路径；有值 → 独立部署指向外部 proxy
//
// Node 执行环境（proxy 自己动态 import 这条 service 链路时，比如 MCP 的 start_analysis
// 任务）没有"当前页面域名"这个浏览器概念——相对路径在这里会直接让 fetch 报错（找不到
// origin 可以解析）。IS_NODE 检测到这种情况时，必须显式指向 proxy 自己的地址，而不是空字符串。
const IS_NODE = typeof window === 'undefined';
export const RD_BASE = IS_NODE
  ? (process.env.RD_BASE_INTERNAL || `http://localhost:${process.env.PORT || 3001}`)
  : (IS_DEV ? "" : (process.env.REACT_APP_PROXY || ""));
export const SKILL_KEY = "rdsk_cbc99b05a42e43b4b7fbb37d7f8a7234";

export function proxyLogo(url) {
  if (!url) return "";
  if (!url.includes("rootdata.com") || IS_DEV) return url;
  return `${RD_BASE}/img-proxy?url=${encodeURIComponent(url)}`;
}
